import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Update the path if necessary

const CurrencyType = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencyTypes, setCurrencyTypes] = useState([
    { currency: "LKR", status: "Active", id: 1 },
    { currency: "USD", status: "Active", id: 2 },
    { currency: "GBP", status: "Inactive", id: 3 },
    { currency: "INR", status: "Active", id: 4 },
  ]);

  const [formData, setFormData] = useState({
    currency: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [currencyTypes]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCurrency) {
      setCurrencyTypes(
        currencyTypes.map((c) =>
          c.id === selectedCurrency.id ? { ...formData, id: c.id } : c
        )
      );
    } else {
      setCurrencyTypes([
        ...currencyTypes,
        {
          ...formData,
          id: currencyTypes.length ? currencyTypes[currencyTypes.length - 1].id + 1 : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ currency: "", status: "Active" });
    setSelectedCurrency(null);
  };

  const handleEdit = (currency) => {
    setSelectedCurrency(currency);
    setFormData({
      currency: currency.currency,
      status: currency.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedCurrency(null);
    setFormData({ currency: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="currency-type-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedCurrency ? "Edit Currency Type" : "Add Currency Type"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Currency:</label>
              <input
                type="text"
                name="currency"
                value={formData.currency}
                onChange={handleChange}
                required
                className="form-control"
                placeholder="Ex: LKR, USD, GBP"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
              Cancel
            </button>
          </form>
        </div>
      )}

      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Currency Types</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Currency
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Currency</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currencyTypes.map((currency) => (
                  <tr key={currency.id}>
                    <td>{currency.currency}</td>
                    <td>
                      <span
                        className={`badge ${
                          currency.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {currency.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(currency)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyType;
